const ConversionStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  UPLOADED: 'UPLOADED',
  FAILED: 'FAILED',
};

Object.freeze(ConversionStatus); // Optional: Prevents modification of the enum

export default ConversionStatus;